// extracted by mini-css-extract-plugin
export default {"surcontainer":"removeTile_surcontainer__dLI7o","container":"removeTile_container__JAQPx","fadein":"removeTile_fadein__LgDXn","img":"removeTile_img__zr9hc"};